module.exports = __webpack_public_path__ + "media/assets/player/prev-d328a38666b4a5e4a34aa1af59025421.svg";